<button class="btn btn-sm btn-ghost" (click)="exportPdf()" >
	<span nz-icon nzType="file-pdf" nzTheme="outline"></span>{{busy ? 'Exporting PDF...' : 'Export PDF'}}
</button>
